import { CREATE_VIDEOS, DELETE_VIDEO, FETCH_VIDEOS, UPDATE_VIDEO, VIDEOS_FAIL, VIDEOS_SUCCESS } from "../actions/type";

const initialState = {
    isLoadingVideos : false,
    videos : null,
    error:null,
    reload: false
}

export default function (state=initialState, action){
    switch(action.type){
       case FETCH_VIDEOS :
         return {...state, isLoadingVideos : true, error:null, reload:false}
       case VIDEOS_SUCCESS:
        return {...state, videos: action.payload, isLoadingVideos: false, error:null}
       case CREATE_VIDEOS:
        return {...state,isLoadingVideos: false, error:null, reload:true}
       case UPDATE_VIDEO :
        return {...state,isLoadingVideos: false, error:null, reload:true}
       case DELETE_VIDEO :
        return {...state,isLoadingVideos: false, error:null, reload:true}
       case VIDEOS_FAIL:
        return {...state, isLoadingVideos:false, error: action.payload} 
        default: 
        return state
    }
}
